import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ALL_USERS, EDIT_USERS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllUsersDataActionTypes, IEditUsersAdministration } from './types';
import userApi from 'src/utils/api/userApi';

export const loadAllUsersAdministration =
  (
    params: string,
  ): ThunkAction<Promise<void>, State, null, AllUsersDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ALL_USERS + REQUEST });
    try {
      const payload = await userApi.loadAllUsersAdministration(params);
      dispatch({ type: ALL_USERS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_USERS + FAILURE, error });
    }
  };

export const editChangeUsersAdministration = (
  data: IEditUsersAdministration,
) => ({
  type: EDIT_USERS,
  payload: data,
});
